import React from 'react';
import { componentsRedux } from 'redux/reusable';
import { useDataPointSubQuerys } from 'apollo/water-preparation/getSubQueries';

const Subqueries = (props) => {
  const { yearStart, yearEnd, weekStart, weekEnd } = props;
  const { data, loading } = useDataPointSubQuerys({
    yearStart,
    yearEnd,
    weekStart,
    weekEnd,
  });
  return <div>{props.children({ loading, data: data.Subqueries })}</div>;
};

export default componentsRedux(Subqueries);
